import React from 'react'
import PropTypes from 'prop-types'
import { renderRawWithLinksHack } from './Utilities/RichTextRenderer'

function LegalStatement({ data, isStats }) {
  // TODO Make this work within disclosures
  const content = renderRawWithLinksHack(data.statement, 'flat-link--grey-dark')

  return <p className={`legal-statement__text ${isStats ? 'stats-legal-text' : ''}`}>{content}</p>
}

LegalStatement.defaultProps = {
  data: null,
  isStats: false
}

LegalStatement.propTypes = {
  data: PropTypes.object,
  isStats: PropTypes.bool
}
export { query as data } from './LegalStatement/LegalStatementQuery'

export default LegalStatement
